<template>
  <div class="border border-border-blue rounded-md p-5 mb-4">
    <div class="flex items-center mb-5">
      <InlineSvg :src="IconDoneStep" />
      <div class="text-main text-xl font-semibold ml-2">Dictations</div>
    </div>
    <div class="pr-5">
      <el-skeleton v-if="isLoading || isRefetching" :rows="rows" animated class="p-5" />
      <div v-else>
        <el-table
          :data="data"
          class="advisor-table"
          row-class-name="row-class"
          header-cell-class-name="custom-header-table"
          style="width: 100%"
          empty-text="No Records Found."
          row-key="id"
          border
          @sort-change="change"
        >
          <el-table-column prop="name" label="Dictations Name" min-width="250">
            <template #default="scope">
              <div class="text-sm text-gray-700 break-words" :class="{ 'cursor-pointer': isCursor }">
                {{ scope.row.name || '-' }}
              </div>
            </template>
          </el-table-column>

          <el-table-column prop="date" label="Meeting Date" min-width="160" sortable>
            <template #default="scope">
              <span class="text-sm text-gray-700 break-words">{{ scope.row.date || '-' }}</span>
            </template>
          </el-table-column>

          <el-table-column prop="advisor" label="Advisor" min-width="180">
            <template #default="scope">
              <span class="text-sm text-gray-700 break-words">
                {{ scope.row.advisor ? scope.row.advisor.first_name + ' ' + scope.row.advisor.last_name : '-' }}
              </span>
            </template>
          </el-table-column>

          <el-table-column prop="created_at" label="Created Date" min-width="150" sortable>
            <template #default="scope">
              <span class="text-sm text-gray-700 break-words">{{ formatDate(scope.row.created_at) }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, ref, computed } from 'vue'
import { useFetchMeetingNotesList } from '@/api/use-fetch-meeting-notes-list'
import { usePaginationData } from '@/utils/use-pagination-data.js'
import { useRoute } from 'vue-router'
import IconDoneStep from '@/assets/svg/icon-done-step.svg'

export default defineComponent({
  name: 'NotesInfo',

  props: {
    memberData: {
      type: Object,
      required: true,
    },
  },
  emits: ['edit-event', 'delete-event', 'open-new-event'],

  setup(props, { emit }) {
    const search = ref('')
    const route = useRoute()
    const currentPage = encodeURI(route.params.p || 1)
    const { paginationData, handlePaginationChange } = usePaginationData()

    paginationData.page = currentPage

    const {
      isLoading,
      isError,
      data,
      pagination,
      refetch: refetchTasks,
      isRefetching,
    } = useFetchMeetingNotesList({
      page: { page: paginationData.page },
      search: search,
      advisor_id: props.memberData.id,
    })

    const isCursor = computed(() => true)

    const formatDate = (dateStr) => {
      if (!dateStr) return '-'
      const date = new Date(dateStr)
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    }

    const handleEditEvent = (eventId) => {
      emit('edit-event', eventId)
    }

    const deleteEventById = (eventId) => {
      emit('delete-event', eventId)
    }

    const openNewMeetingNotes = () => {
      emit('open-new-event')
    }

    const handleActionSelect = (id, action) => {
      switch (action) {
        case 'edit':
          handleEditEvent(id)
          break
        case 'delete':
          deleteEventById(id)
          break
        default:
          console.log('Action not defined')
      }
    }

    return {
      isLoading,
      isError,
      data,
      pagination,
      refetchTasks,
      isRefetching,
      formatDate,
      IconDoneStep,
      handleEditEvent,
      deleteEventById,
      openNewMeetingNotes,
      handleActionSelect,
      isCursor,
      handlePaginationChange,
    }
  },
})
</script>

<style scoped>
.row-class {
  cursor: pointer;
}
</style>
